module.exports = __webpack_public_path__ + "static/media/oldland.d5fc1e37.png";